export default __webpack_public_path__ + "resources/icons/d320-2dbf.png";